export default function AboutSection() {
  return (
    <section id="about" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              关于我们
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              了解豆花视频的故事与使命
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
            <div className="max-w-3xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                  <i className="ri-movie-2-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-heading text-foreground-900">豆花视频</h3>
                  <p className="text-xs text-foreground-600">美食视频聚合平台</p>
                </div>
              </div>

              <div className="space-y-5">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  豆花视频成立于2024年，是一家专注于聚合美食命名视频平台内容的影视导航站点。
                  我们致力于将香蕉视频、红桃视频、蜜桃视频、西瓜视频、糖豆视频、樱桃视频、蘑菇视频等优质平台的
                  电视剧全集和最新电影整合到一个入口，让用户告别多个平台反复切换的烦恼。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  我们的团队由一群热爱影视内容的年轻人组成，每天跟踪各大平台的内容更新动态，
                  第一时间为用户筛选和推荐优质资源。我们坚持"免费、高清、流畅"的产品理念，
                  希望通过豆花视频让每个人都有更好的追剧观影体验。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  截至目前，豆花视频已覆盖7个美食视频平台，收录数百部电视剧全集和最新电影资源，
                  日均服务数万影视爱好者。我们将继续拓展内容源，优化搜索和推荐功能，
                  努力成为大家追剧观影的首选入口。
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
                <div className="text-center p-5 rounded-xl bg-primary-50">
                  <div className="text-2xl font-heading text-primary-600 mb-1">7+</div>
                  <div className="text-xs text-foreground-600">覆盖视频平台</div>
                </div>
                <div className="text-center p-5 rounded-xl bg-accent-50">
                  <div className="text-2xl font-heading text-accent-600 mb-1">500+</div>
                  <div className="text-xs text-foreground-600">收录影视作品</div>
                </div>
                <div className="text-center p-5 rounded-xl bg-secondary-50">
                  <div className="text-2xl font-heading text-secondary-600 mb-1">10万+</div>
                  <div className="text-xs text-foreground-600">日均观影用户</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}